import { LOGGER } from '@cicero/data/utils'
import { IAction, IActionHandler, Store } from 'models/services'
import { IQuery, IS_OFFLINE_ID, WrongParamsError } from 'models/helpers'

export class FETCH_MODEL_OVER_HTTP implements IActionHandler<IFetchParamsPayload, any> {
  async exec(action: IAction<IFetchParamsPayload>, store: Store) {
    if (!action.payload) { throw new Error('Action has no payload') }
    const { model, params } = action.payload
    const { selector } = params
    const M = store.getModelByName(model || '')
    if (M.schema.LIFECYCLE.fetch === undefined) {
      LOGGER.warn(`There is no fetch function configured for model: ${model}`)
      return
    }

    if (selector && selector.id && IS_OFFLINE_ID(selector.id)) {
      LOGGER.warn(`Swallowing fetch for offline ID "${selector.id}"`)
      return
    }

    const result = await M.schema.LIFECYCLE.fetch(store, params)

    if (result === null) { return null }
    if (result === undefined) {
      throw new WrongParamsError(`A fetch for model "${model}" returned undefined. This is probably a bug. Return null for no match " `, params)
    }

    return M.PERSIST(result)
  }
}

interface IFetchParamsPayload {
  model: string
  params: IQuery
}
